import { IToastProps } from "@livechat/design-system";

import { IRequestError } from "store/entities/actions";

export enum ToastVariant {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error",
  Notification = "notification",
}

export enum ToastAutoHideDelay {
  Short = 2500,
  Long = 3500,
  Infinite = 99999999,
}

export enum ToastHorizontalPosition {
  Left = "left",
  Right = "right",
  Center = "center",
}

export enum ToastVerticalPosition {
  Top = "top",
  Bottom = "bottom",
}

interface IToastAction {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler(): any;
  label: string;
  closeOnClick?: boolean;
}

export interface IToastDetails extends IToastProps {
  id: string;
  content: React.ReactNode;
  horizontalPosition: ToastHorizontalPosition;
  verticalPosition: ToastVerticalPosition;
  consumerName?: string;
}

interface IToastsBasePayload {
  id: string;
  autoHideDelayTime: number;
  horizontalPosition: ToastHorizontalPosition;
  verticalPosition: ToastVerticalPosition;
  variant: ToastVariant;
  content: React.ReactNode;
  removable: boolean;
  action?: IToastAction;
}

export interface ICreateToastActionParams {
  content?: React.ReactNode;
  autoHideDelayTime?: number;
  horizontalPosition?: ToastHorizontalPosition;
  verticalPosition?: ToastVerticalPosition;
  variant?: ToastVariant;
  action?: IToastAction;
  id?: string;
  removable?: boolean;
  error?: IRequestError;
}

export type IToastsCreatePayload = IToastsBasePayload;

export type IToastsShowPayload = IToastsBasePayload;

export interface IToastsRemovePayload {
  id: string;
}
